import SelectOptionsAndColors from './SelectOptionsAndColors';
import './SelectOptionsAndColors.scss';

export default SelectOptionsAndColors;